import { collection, query, getDocs, where, updateDoc, doc, DocumentData } from 'firebase/firestore';
import { db } from '../../../config/firebase';
import DbCollections from '../../../resources/enums/DbCollections';
import { getAvailableTimeMapKey } from '../../coach/utils';
import { MeetingType, MeetingsMap } from '../types';

export const getMeetingsListFirebase = async (coachId: string) => {
    const meetingsSnapshot = await getDocs(
        query(collection(db, DbCollections.Meetings), where('coachId', '==', coachId)),
    );

    const meetingsMap = meetingsSnapshot.docs.reduce(
        (acc: MeetingsMap, cur: DocumentData) => {
            const meetingDate = cur.data();
            const meeting = { ...meetingDate, date: meetingDate.date.toDate(), id: cur.id };
            const mapKey = getAvailableTimeMapKey(meeting.date);

            if (meeting.cancelled) {
                const existingMeetings = acc[MeetingType.Cancelled][mapKey];
                const meetingsByDay = existingMeetings ? [...existingMeetings, meeting] : [meeting];
                return {
                    ...acc,
                    [MeetingType.Cancelled]: { ...acc[MeetingType.Cancelled], [mapKey]: meetingsByDay },
                } as MeetingsMap;
            }

            const existingMeetings = acc[MeetingType.Confirmed][mapKey];
            const meetingsByDay = existingMeetings ? [...existingMeetings, meeting] : [meeting];
            return {
                ...acc,
                [MeetingType.Confirmed]: { ...acc[MeetingType.Confirmed], [mapKey]: meetingsByDay },
            } as MeetingsMap;
        },
        { [MeetingType.Confirmed]: {}, [MeetingType.Cancelled]: {} },
    );

    return meetingsMap;
};

export const updateMeetingNoteFirebase = async (meetingId: string, note: string) => {
    return updateDoc(doc(db, DbCollections.Meetings, meetingId), {
        meetingNote: note,
    });
};
